// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__JzKWc","loaderOuter":"PageOverlayLoader_loaderOuter__3zcsj"};